/*!
 * Built by Revolist
 */
import { R as RevogrFocus$1, d as defineCustomElement$1 } from './revogr-focus2.js';

const RevogrFocus = RevogrFocus$1;
const defineCustomElement = defineCustomElement$1;

export { RevogrFocus, defineCustomElement };
